<template>
  <div class="BoxWide">
    <div class="RegistroInterventi">
      <div class="TabellaRegistro">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <td class="TRCod">
                <div class="TRIndex">
                  <div>Codice intervento</div>
                  <div>{{ this.intervento.CodiceIntervento }}</div>
                </div>
              </td>
              <td class="TREff">
                <div class="TRIndex Bordered">
                  <div>Da effettuare entro</div>
                  <div>{{ this.formatDate(intervento.DataDaEffettuarsiEntro) }}</div>
                </div>
              </td>
              <td class="TRTip">
                <div class="TRIndex">
                  <div>Tipo</div>
                  <div>{{ intervento.Tipo ?? "-" }}</div>
                </div>
              </td>
              <td class="TRRic">
                <div class="TRIndex">
                  <div>Data/Richiesto da</div>
                  <div>{{ this.formatDate(intervento.Data) }}</div>
                </div>
              </td>
              <td class="TRSit">
                <div class="TRIndex">
                  <div>Sito / Unità</div>
                  <div>{{ this.$store.getters.getDescrizioneOperativa(intervento.CodiceSito) ?? "-" }}</div>
                </div>
              </td>
              <td class="TRSta">
                <div class="TRIndex">
                  <div>Stato</div>
                  <div>
                    {{ this.$store.getters.getDescrizioneStato(intervento.CodiceStato) }}
                    <Popper>  
                            <a class="fancybox.iframe FancySizes InfoPopUpOpen" style="font-size: 13px; text-transform: lowercase;">i</a>                        
                            <template #content>
                              <label for="noteAsseganz">Note Assegnazione:</label>
                              <p id = "noteAsseganz" class="noteInfo">{{intervento.NoteAssegnazione ?? "-" }}</p>
                              <br>
                              <hr>
                              <br>
                              <label for = "dataPresaInCarico">Da Effettuarsi Entro:</label>
                              <p id = "dataPresaInCarico">{{this.formatDateNoOre(intervento.DataNonOltre) ?? "-"}}</p>
                              <br>
                              <label for="notePresaInCarico">Firma Assegnazione:</label>
                              <p id ="notePresaInCarico">{{intervento.FirmaAssegnazione ?? "-" }}</p>                      
                            </template>
                    </Popper>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ToggleButton">
        <div class="Dettagli Button Iconed Stroked Toggled ExtraSmall">
          <span  @click="this.mostraDettagli(index, intervento.CodiceIntervento, intervento.SysChiaveglobale, $event)">Dettagli</span>
        </div>
      </div>
    </div>
    <div class="PannelloDettagli StoricoInterventi" style="display:none" :id="'pannDett' + index">
      <keep-alive>
        <component 
        :is="currentPannDett"
        :codiceIntervento="intervento.CodiceIntervento"
        :chiaveIntervento = "this.chiaveIntervento"        
        ></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>


import {dateMixin, apiMixin, griglieInterventiMixin} from "/mixin.js";
import PannDettInterventiStorico from "@/components/PannDettInterventiStorico.vue";
import Popper from "vue3-popper";

export default {
  name: "RigaInterventoStorico",
  props: {
    intervento: Object,
    index: Number
  },
  data(){
    return {
      openDett: false,
      chiaveIntervento: "",
    }
  },
  components:{
    PannDettInterventiStorico,
    Popper
  },
  mixins: [dateMixin, apiMixin, griglieInterventiMixin],
  computed: {
    currentPannDett(){ 
      let comp =  this.openDett ? "EmptyComponent" : "PannDettInterventiStorico";           
      return comp;
    }   
  },
};
</script>